import React from 'react'
import Markdown from 'react-markdown'
import Button from 'antd/lib/button'
import l8n from 'l8n'

import './style.scss'

class CookieBanner extends React.Component {
  render() {
    const {show, showRefuseButton, onAcceptCookies, onRefuseCookies} = this.props

    if (show !== true) {
      return null
    }

    return (
      <div className={`cookie-consent cookie-consent_locale_${l8n.locale}`}>
        <div className="cookie-consent__message">
          <Markdown source={l8n['cookieConsent.message']}/>
        </div>
        <div className="cookie-consent__buttons">
          {showRefuseButton && (
            <Button
              className="cookie-consent__button cookie-consent__button_refuse"
              type="default"
              onClick={onRefuseCookies}
            >
              {l8n['cookieConsent.refuse']}
            </Button>
          )}
          <Button
            className="cookie-consent__button cookie-consent__button_accept"
            type="primary"
            onClick={onAcceptCookies}
          >
            {l8n['cookieConsent.accept']}
          </Button>
        </div>
      </div>
    )
  }
}

export default CookieBanner



// WEBPACK FOOTER //
// ./src/components/CustomComponents/CookieConsent/components/Banner/index.js